import RegistrationFormFactory from './RegistrationFormFactory';

export default RegistrationFormFactory;
